<template>
  <div class="upgrade-history-page pk-account-panel">
    <section class="history-hero">
      <button class="back-btn" @click="$router.push({ path: '/Ornament' })">返回</button>
      <span>升级</span>
      <h1>饰品升级记录</h1>
      <p>展示当前账号的升级记录，相关时间、物品和结果以记录页面展示为准。</p>
    </section>

    <history-list
      v-if="loggedIn"
      :list="tableData"
      :total="totalSize"
      :page-size="pageSize"
      @page="currentChange"
    />

    <section v-else class="record-auth-card">
      <img src="@/assets/hotpizza/hp-case-green.png" alt="" />
      <div>
        <span>需要登录</span>
        <strong>登录后查看升级记录</strong>
        <p>升级记录绑定当前账号，登录后可查看完整记录。</p>
      </div>
      <button @click="openLogin">登录账号</button>
    </section>
  </div>
</template>

<script>
const HistoryList = {
  props: ["list", "total", "pageSize"],
  methods: {
    moneyText(value) {
      return Number(value || 0).toFixed(2);
    },
  },
  template: `
    <section>
      <div class="record-list" v-if="list.length">
        <article v-for="(item, index) in list" :key="item.time + index" class="record-card">
          <div>
            <span>{{ item.time }}</span>
            <strong>{{ item.skins }}</strong>
          </div>
          <div class="record-meta">
            <span>玩家 {{ item.name }}</span>
            <span>概率 {{ item.probability }}%</span>
          </div>
          <div class="record-result" :class="{ success: item.status === '成功' }">
            <strong>{{ item.status }}</strong>
            <em>{{ moneyText(item.price) }}</em>
          </div>
        </article>
      </div>
      <div v-else class="empty-card">暂无升级记录。</div>
      <el-pagination
        v-if="total > pageSize"
        class="history-page-nav"
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        @current-change="$emit('page', $event)"
      ></el-pagination>
    </section>
  `,
};

export default {
  components: { HistoryList },
  data() {
    return {
      totalSize: 0,
      page: 1,
      pageSize: 10,
      tableData: [],
    };
  },
  mounted() {
    if (this.loggedIn) {
      this.getluckyhist(this.page);
    }
  },
  computed: {
    loggedIn() {
      return Boolean(this.$store.state.token);
    },
  },
  watch: {
    loggedIn(value) {
      if (value) {
        this.getluckyhist(this.page);
      }
    },
  },
  methods: {
    getluckyhist(page) {
      this.page = page;
      this.$axios
        .post("/index/Lucky/LuckyHistory", this.$qs.stringify({ page, pageSize: this.pageSize }))
        .then((res) => {
          if (res.data.status == "1") {
            this.totalSize = res.data.data.total;
            this.tableData = res.data.data.list;
          }
        });
    },
    currentChange(val) {
      this.getluckyhist(val);
    },
    openLogin() {
      this.$store.commit("getLogin", true);
    },
  },
};
</script>

<style lang="less" scoped>
.upgrade-history-page {
  min-height: calc(100vh - 198px);
  padding: 34px 34px 90px;
  color: #f5f7ff;
  background:
    radial-gradient(circle at 48% 0, rgba(255, 138, 31, 0.16), transparent 30%),
    radial-gradient(circle at 84% 28%, rgba(0, 217, 255, 0.1), transparent 28%),
    linear-gradient(180deg, #1f212d 0%, #171923 100%);
}

button {
  font-family: inherit;
  cursor: pointer;
}

.history-hero,
.record-list,
.empty-card,
.record-auth-card,
.history-page-nav {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
}

.history-hero {
  min-height: 260px;
  padding: 46px 54px;
  position: relative;
  overflow: hidden;
  border-radius: 18px;
  background:
    linear-gradient(130deg, rgba(41, 43, 58, 0.96), rgba(24, 26, 36, 0.98)),
    url("../assets/new/task_bg.png") center / cover;
  border: 1px solid rgba(255, 132, 31, 0.28);
  box-shadow: 0 26px 80px rgba(0, 0, 0, 0.34);
}

.history-hero::after {
  content: "";
  width: 780px;
  height: 280px;
  position: absolute;
  right: -170px;
  bottom: -160px;
  border-radius: 50%;
  background: radial-gradient(ellipse, rgba(255, 138, 0, 0.38), transparent 66%);
}

.back-btn {
  height: 44px;
  padding: 0 20px;
  position: absolute;
  right: 22px;
  top: 22px;
  z-index: 2;
  color: #f4f6ff;
  background: #303342;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 7px;
  font-weight: 1000;
}

.history-hero span {
  position: relative;
  z-index: 1;
  color: #ff8a1f;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.18em;
}

.history-hero h1 {
  position: relative;
  z-index: 1;
  margin: 12px 0 14px;
  font-size: 64px;
  line-height: 0.98;
  font-weight: 1000;
}

.history-hero p {
  position: relative;
  z-index: 1;
  max-width: 760px;
  color: #aeb6c8;
  font-size: 17px;
  line-height: 1.8;
  font-weight: 800;
}

.record-list {
  margin-top: 22px;
  display: grid;
  gap: 10px;
}

.record-card {
  min-height: 88px;
  padding: 16px 18px;
  display: grid;
  grid-template-columns: 1.4fr 1fr 150px;
  gap: 18px;
  align-items: center;
  border-radius: 12px;
  background: linear-gradient(180deg, rgba(43, 45, 59, 0.95), rgba(31, 33, 45, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.record-card span {
  color: #8f98ab;
  font-size: 13px;
  font-weight: 900;
}

.record-card strong {
  display: block;
  margin-top: 6px;
  color: #f7f9ff;
  font-size: 16px;
  font-weight: 1000;
}

.record-meta {
  display: grid;
  gap: 7px;
}

.record-result {
  text-align: right;
}

.record-result strong {
  color: #ff6969;
}

.record-result.success strong {
  color: #62f06c;
}

.record-result em {
  display: block;
  margin-top: 6px;
  color: #ffd764;
  font-size: 20px;
  font-style: normal;
  font-weight: 1000;
}

.empty-card {
  margin-top: 18px;
  padding: 34px 18px;
  color: #929bad;
  text-align: center;
  background: #242735;
  border: 1px solid rgba(255, 255, 255, 0.055);
  border-radius: 10px;
  font-size: 14px;
  font-weight: 800;
}

.record-auth-card {
  min-height: 240px;
  margin-top: 22px;
  padding: 28px;
  display: grid;
  grid-template-columns: 180px minmax(0, 1fr) auto;
  gap: 24px;
  align-items: center;
  background:
    radial-gradient(circle at 12% 50%, rgba(255, 138, 31, 0.24), transparent 34%),
    linear-gradient(180deg, rgba(43, 45, 59, 0.95), rgba(31, 33, 45, 0.98));
  border: 1px solid rgba(255, 132, 31, 0.24);
  border-radius: 14px;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.24);
}

.record-auth-card img {
  width: 170px;
  max-height: 150px;
  object-fit: contain;
  filter: drop-shadow(0 20px 28px rgba(255, 138, 31, 0.22));
}

.record-auth-card span {
  color: #ff8a1f;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.18em;
}

.record-auth-card strong {
  display: block;
  margin-top: 8px;
  color: #fbfcff;
  font-size: 30px;
  font-weight: 1000;
}

.record-auth-card p {
  max-width: 620px;
  margin: 10px 0 0;
  color: #aeb7c8;
  font-size: 15px;
  line-height: 1.7;
  font-weight: 800;
}

.record-auth-card button {
  height: 44px;
  padding: 0 24px;
  color: #151620;
  background: linear-gradient(180deg, #ffd53b, #ff8300);
  border: 0;
  border-radius: 8px;
  font-weight: 1000;
  cursor: pointer;
  box-shadow: 0 14px 34px rgba(255, 131, 0, 0.24);
}

.history-page-nav {
  margin-top: 18px;
  text-align: right;
}

.history-page-nav /deep/ .el-pager li:not(.disabled).active {
  color: #151620;
  background: #ffae1d;
}

.history-page-nav /deep/ .el-pagination.is-background .btn-next,
.history-page-nav /deep/ .el-pagination.is-background .btn-prev,
.history-page-nav /deep/ .el-pagination.is-background .el-pager li {
  color: #aab3c6;
  background: #242735;
}

@media screen and (max-width: 980px) {
  .upgrade-history-page {
    padding: 20px 12px 64px;
  }

  .history-hero {
    padding: 72px 24px 34px;
  }

  .history-hero h1 {
    font-size: 46px;
  }

  .record-card {
    grid-template-columns: 1fr;
  }

  .record-auth-card {
    grid-template-columns: 1fr;
  }

  .record-result {
    text-align: left;
  }
}
</style>

<style lang="less">
.upgrade-history-page.pk-account-panel {
  min-height: calc(100vh - 199px) !important;
  padding: 24px 24px 96px !important;
  background:
    radial-gradient(circle at 50% 0, rgba(253, 107, 1, 0.08), transparent 360px),
    #191b26 !important;
}

.upgrade-history-page.pk-account-panel .history-hero,
.upgrade-history-page.pk-account-panel .record-list,
.upgrade-history-page.pk-account-panel .empty-card,
.upgrade-history-page.pk-account-panel .record-auth-card,
.upgrade-history-page.pk-account-panel .history-page-nav {
  width: 100% !important;
  max-width: none !important;
}

.upgrade-history-page.pk-account-panel .history-hero {
  min-height: 260px !important;
  padding: 30px 38px !important;
  border: 1px solid #2b2d3c !important;
  border-radius: 8px !important;
  background:
    radial-gradient(circle at 14% 48%, rgba(255, 132, 31, 0.15), transparent 280px),
    #20222f !important;
  box-shadow: none !important;
}

.upgrade-history-page.pk-account-panel .record-list {
  gap: 8px !important;
}

.upgrade-history-page.pk-account-panel .record-card,
.upgrade-history-page.pk-account-panel .record-auth-card,
.upgrade-history-page.pk-account-panel .empty-card {
  border-color: #2b2d3c !important;
  border-radius: 8px !important;
  background: #20222f !important;
  box-shadow: none !important;
}

.upgrade-history-page.pk-account-panel .record-card {
  min-height: 88px !important;
  grid-template-columns: minmax(0, 1.4fr) minmax(230px, 0.8fr) 150px !important;
}
</style>

<style lang="less">
.upgrade-history-page.pk-account-panel {
  padding: 32px 28px 96px !important;
}

.upgrade-history-page.pk-account-panel .history-hero,
.upgrade-history-page.pk-account-panel .record-list,
.upgrade-history-page.pk-account-panel .empty-card,
.upgrade-history-page.pk-account-panel .record-auth-card,
.upgrade-history-page.pk-account-panel .history-page-nav {
  width: calc(100% - 24px) !important;
  max-width: 1540px !important;
}

.upgrade-history-page.pk-account-panel .history-hero {
  min-height: 304px !important;
  border-color: rgba(255, 132, 31, 0.38) !important;
  box-shadow:
    0 28px 90px rgba(0, 0, 0, 0.38),
    inset 0 1px 0 rgba(255, 224, 170, 0.08) !important;
}

.upgrade-history-page.pk-account-panel .record-list {
  gap: 12px !important;
}

.upgrade-history-page.pk-account-panel .record-card {
  min-height: 102px !important;
  grid-template-columns: minmax(0, 1.5fr) minmax(260px, 0.8fr) 170px !important;
  border-color: rgba(111, 121, 151, 0.22) !important;
}

@media screen and (max-width: 980px) {
  .upgrade-history-page.pk-account-panel {
    padding: 18px 12px 58px !important;
  }

  .upgrade-history-page.pk-account-panel .history-hero,
  .upgrade-history-page.pk-account-panel .record-list,
  .upgrade-history-page.pk-account-panel .empty-card,
  .upgrade-history-page.pk-account-panel .record-auth-card,
  .upgrade-history-page.pk-account-panel .history-page-nav {
    width: 100% !important;
  }

  .upgrade-history-page.pk-account-panel .record-card {
    grid-template-columns: 1fr !important;
  }
}
</style>
